import app from 'firebase/app';
import 'firebase/auth';
import 'firebase/firestore';
import { ALL_PRODUCTS, CART, WISHLIST, LISTS } from '../../constants/firebase';

const config = {
  apiKey: "AIzaSyA3sfmhD8kSUjdhhHH_ntnWUOb3muZlASc",
  authDomain: "era-ecommerce-react.firebaseapp.com",
  databaseURL: "https://era-ecommerce-react.firebaseio.com",
  projectId: "era-ecommerce-react",
  storageBucket: "era-ecommerce-react.appspot.com",
  messagingSenderId: "1072314715601"
};

class Firebase {
  constructor() {
    app.initializeApp(config);

    this.db = app.firestore();
    this.auth = app.auth();
    const settings = { timestampsInSnapshots: true };
    this.db.settings(settings);
    this.auth.setPersistence(app.auth.Auth.Persistence.SESSION);
  }

  // *** Auth API ***

  doCreateUserWithEmailAndPassword = (email, password) =>
    this.auth.createUserWithEmailAndPassword(email, password);

  doSignInWithEmailAndPassword = (email, password) =>
    this.auth.signInWithEmailAndPassword(email, password);

  doSignOut = () => this.auth.signOut();

  doPasswordReset = email => this.auth.sendPasswordResetEmail(email);

  doPasswordUpdate = password => this.auth.currentUser.updatePassword(password);
}

const firebase = new Firebase();
const db = firebase.db;

export const allProductsRef = db.collection(ALL_PRODUCTS);
export const cartRef = db.collection(CART);
export const wishlistRef = db.collection(WISHLIST);
export const listsRef = db.collection(LISTS);

export default firebase;
